import { PackageType } from '@frontend/package/types';
import { ScreenType } from '@frontend/wizard/types';

import { useColliConfirmOpenSlotsParallel } from '../../hooks/use-colli-confirm-open-slots-parallel';

const usePickUpConfirmOpenSlotsParallel = () =>
    useColliConfirmOpenSlotsParallel({
        screenType: ScreenType.PICK_UP_CONFIRM_OPEN_SLOTS_PARALLEL,
        packageType: PackageType.PICK_UP
    });

export default usePickUpConfirmOpenSlotsParallel;
